import { useEffect, useState } from 'react';
import { getRuntimeConfig } from '../../shared/runtimeConfigClient';

export function useDatasetRuntimeConfig() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let cancelled = false;
    getRuntimeConfig()
      .then((config) => { if (!cancelled) setEnabled(config.datasetContributionsEnabled === true); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return enabled;
}
